import React, { forwardRef } from 'react';
import uuid from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id = uuid.v4();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id})`}>
                <path d='M21.6 12H19.2C17.88 12 16.8 13.08 16.8 14.4V21.6C16.8 22.92 17.88 24 19.2 24H21.6C22.92 24 24 22.92 24 21.6V14.4C24 13.08 22.932 12 21.6 12ZM21.6 20.4C21.6 21.06 21.06 21.6 20.4 21.6C19.74 21.6 19.2 21.06 19.2 20.4V15.6C19.2 14.94 19.74 14.4 20.4 14.4C21.06 14.4 21.6 14.94 21.6 15.6V20.4ZM4.8 4.8H2.4C1.08 4.8 0 5.88 0 7.2V21.6C0 22.92 1.08 24 2.4 24H4.8C6.12 24 7.2 22.92 7.2 21.6V7.2C7.2 5.88 6.132 4.8 4.8 4.8ZM4.8 20.4C4.8 21.06 4.26 21.6 3.6 21.6C2.94 21.6 2.4 21.06 2.4 20.4V8.4C2.4 7.74 2.94 7.2 3.6 7.2C4.26 7.2 4.8 7.74 4.8 8.4V20.4ZM13.2 0H10.8C9.48 0 8.4 1.08 8.4 2.4V21.6C8.4 22.92 9.48 24 10.8 24H13.2C14.52 24 15.6 22.92 15.6 21.6V2.4C15.6 1.08 14.532 0 13.2 0ZM13.2 20.4C13.2 21.06 12.66 21.6 12 21.6C11.34 21.6 10.8 21.06 10.8 20.4V3.6C10.8 2.94 11.34 2.4 12 2.4C12.66 2.4 13.2 2.94 13.2 3.6V20.4Z' />
            </g>
            <defs>
                <clipPath id={id}>
                    <rect width='24' height='24' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
